import { Reveal, SectionHeading } from "./Reveal";
import { scrollToId } from "../lib/scroll";
import { Quote, CheckCircle2 } from "lucide-react";

const CONFIDENCES = [
  "Je me demande si l'entreprise que je bâtis incarnera encore mes valeurs demain…",
  "J'aimerais que mon équipe ressente la même passion que moi pour notre mission…",
  "Je cherche une croissance qui ne sacrifie pas l'âme de mon entreprise…",
];

const OFFERS = [
  {
    title: "Accompagnement du dirigeant",
    text: "Clarté stratégique, solitude du décideur, charge mentale : un espace de recul confidentiel pour penser autrement et décider juste.",
  },
  {
    title: "QVT / QVCT",
    text: "Qualité de vie et des conditions de travail : diagnostic, prévention des risques psychosociaux, plans d'action concrets et mesurables.",
  },
  {
    title: "Cohésion des équipes de direction",
    text: "Faire d'un comité de direction une vraie équipe : communication, confiance, dynamiques collectives.",
  },
  {
    title: "Ateliers & formations",
    text: "Gestion du stress, préparation mentale, intelligence émotionnelle : des formats sur mesure, en présentiel, pour vos équipes.",
  },
];

export default function PmeSection() {
  return (
    <section id="dirigeants" data-testid="pme-qvt-section-container" className="relative py-28 lg:py-36 bg-[#0C1526]">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <div className="lg:sticky lg:top-28">
            <SectionHeading
              overtitle="Dirigeants de PME & QVT"
              title="Remettre l'humain au centre de la stratégie."
            />
            <Reveal delay={0.2}>
              <p className="mt-6 text-base sm:text-lg text-slate-400 leading-relaxed">
                Les entreprises les plus résilientes sont celles qui ont une âme. Depuis plus de
                quinze ans, j'aide des dirigeants passionnés à transformer leur vision en réalité
                durable — en commençant par une question essentielle :
              </p>
            </Reveal>
            <Reveal delay={0.3}>
              <p className="font-serif-display mt-6 text-2xl italic text-gold-gradient">
                « Quelle empreinte souhaitez-vous laisser ? »
              </p>
            </Reveal>
            <Reveal delay={0.4}>
              <button
                data-testid="pme-cta-booking-button"
                onClick={() => scrollToId("#contact")}
                className="mt-10 rounded-full border border-[#D4AF37]/50 px-8 py-4 text-sm font-medium text-[#F3E5AB] transition-all duration-300 hover:bg-[#D4AF37] hover:text-[#0A1120]"
              >
                Échanger sur votre entreprise
              </button>
            </Reveal>
          </div>

          <div className="space-y-5">
            {CONFIDENCES.map((quote, i) => (
              <Reveal key={i} delay={i * 0.1}>
                <figure
                  data-testid={`pme-confidence-${i}`}
                  className="flex gap-4 rounded-xl border border-[#D4AF37]/10 bg-[#0A1120]/70 p-6"
                >
                  <Quote size={20} className="shrink-0 text-[#D4AF37]/60 mt-1" />
                  <blockquote className="font-serif-display text-lg italic text-slate-300 leading-relaxed">
                    {quote}
                  </blockquote>
                </figure>
              </Reveal>
            ))}
          </div>
        </div>

        <div className="mt-24 grid sm:grid-cols-2 gap-5">
          {OFFERS.map((o, i) => (
            <Reveal key={o.title} delay={i * 0.1}>
              <div
                data-testid={`pme-offer-${i}`}
                className="group h-full rounded-xl border border-[#D4AF37]/12 p-8 transition-all duration-500 hover:border-[#D4AF37]/40 hover:bg-[#111C33]/50"
              >
                <div className="flex items-center gap-3">
                  <CheckCircle2 size={18} className="text-[#D4AF37]" />
                  <h3 className="font-serif-display text-xl text-white">{o.title}</h3>
                </div>
                <p className="mt-3 text-sm sm:text-base text-slate-400 leading-relaxed">{o.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
